exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-loadpopup {\n  font-size: 0.9rem; }\n  .modal-loadpopup .modal-dialog {\n    max-width: 75% !important;\n    margin: auto; }\n  .modal-loadpopup .modal-body {\n    height: 545px; }\n", ""]);

// exports
